import React, { useEffect, useState } from 'react';
import './styles/Referral.css';
import { ReferralStats } from '../dto/Referral.dto';
import { ReferralService } from '../service/Referral.service';
import { ApiService } from '../../../shared/service/Apiservice';
import axios from 'axios';

const Referrals: React.FC = () => {
  const [stats, setStats] = useState<ReferralStats | null>(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [referralCode, setReferralCode] = useState('');
  const apiService = React.useMemo(() => new ApiService(axios.create()), []);
  const referralService = React.useMemo(() => new ReferralService(apiService), [apiService]); // Now uses /referrals endpoints

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    const response = await referralService.getReferralStats();
    if (response.success && response.data) {
      setStats(response.data);
      setReferralCode(response.data.referralCode || '');
    }
  };

  const handleGenerateCode = async () => {
    setIsGenerating(true);
    try {
      const response = await referralService.createReferral({
        rewardAmount: 50,
        referrerReward: 50,
        referredReward: 25,
        maxReferrals: 10,
        rewardType: 'credit',
      });
      if (response.success) {
        await fetchStats();
      }
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="referrals-container">
      {/* Header Section */}
      <div className="referrals-header">
        <h2 className="referrals-title">Referrals</h2>
        <p className="referrals-subtitle">
          Invite your friends to Upshift. If they sign up, you earn 50 for free!!
        </p>
      </div>

      {/* Yellow Banner Card */}
      <div className="banner-card">
        <img 
          src="/images/refferl.png" 
          alt="Refer and Earn" 
          className="banner-image"
        />
      </div>

      {/* Stats Cards Row */}
      <div className="stats-row">
        <div className="stat-card">
          <p className="stat-label">TOTAL REFERRALS</p>
          <p className="stat-value">{stats?.totalReferrals ?? 0}</p>
        </div>
        <div className="stat-card">
          <p className="stat-label">COMPLETED SIGNUP</p>
          <p className="stat-value">{stats?.completedReferrals ?? 0}</p>
        </div>
        <div className="stat-card">
          <p className="stat-label">TOTAL EARNED</p>
          <p className="stat-value">
            <span className="rupee-icon">₹</span>{stats?.totalEarned ?? 0}
          </p>
        </div>
        <div className="stat-card">
          <p className="stat-label">CONVERSION RATE</p>
          <p className="stat-value">
            {stats?.conversionRate?.toFixed(1) ?? 0}<span className="percent-icon">%</span>
          </p>
        </div>
      </div>

      {/* Process Steps */}
      <div className="process-container">
        <div className="process-step">
          <div className="step-circle">
            <img src="/icon/massage.png" alt="Send Invitation" />
          </div>
          <img src="/icon/ziczacline.png" alt="line" className="zigzag-line" />
          <div className="step-content">
            <h3 className="step-title">Send Invitation</h3>
            <p className="step-description">
              Send your referral link to<br />
              friends and tell them<br />
              how to Upshift this!
            </p>
          </div>
        </div>

        <div className="process-step">
          <div className="step-circle">
            <img src="/icon/register.png" alt="Registration" />
          </div>
          <img src="/icon/ziczacline.png" alt="line" className="zigzag-line" />
          <div className="step-content">
            <h3 className="step-title">Registration</h3>
            <p className="step-description">
              Let them to Sign Up<br />
              here and Earn ₹ 50<br />
              on each Referral
            </p>
          </div>
        </div>

        <div className="process-step">
          <div className="step-circle">
            <img src="/icon/reward.png" alt="Get Rewarded" />
          </div>
          <div className="step-content">
            <h3 className="step-title">Get Rewarded</h3>
            <p className="step-description">
              friend get ₹ 25
            </p>
          </div>
        </div>
      </div>

      {/* Share Section */}
      <div className="share-section">
        <h3 className="share-title">Share the referral link</h3>
        <p className="share-description">
          You can share your referral link by copying and sending it or sharing it on your Social Media.
        </p>
        <div className="referral-input-container">
          <div className="referral-input-wrapper">
            <input 
              type="text" 
              className="referral-input" 
              value={referralCode}
              placeholder="Your referral code"
              readOnly
            />
          </div>
          <button className="generate-code-btn" onClick={handleGenerateCode} disabled={isGenerating || !!referralCode}>
            {isGenerating ? 'Generating...' : referralCode ? 'Code Generated' : 'Generate Code'}
          </button>
        </div>
      </div>

      {/* Bonus Card */}
      <div className="bonus-card">
        <p className="bonus-text">
          You're 3 Referrals away from ₹ 500 Bonus BuildZap Coins
        </p>
      </div>
    </div>
  );
};

export default Referrals;